module.exports = __webpack_public_path__ + "static/media/volley.8f2a79e2.png";